// extracted by mini-css-extract-plugin
export default {"component":"Z1P6Y","item":"dA29b","carousel":"pXGUw"};